<template>
    <div class="border-b">
        <span
            class="py-2 sound-notification-item"
            v-html="sound.notificationHTML"
        />
        <span
            v-show="timerState"
            class="sound-notification-item-timer"
        >
            {{ `${timerDisplayTime}.` }}
        </span>
        <div class="py-3 opacity-40">
            {{ getSoundDate() }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { useTimer } from '@/composables/useTimer'
import { watch } from 'vue'
import { ISoundItem } from '@/types/sound'

const props = defineProps<{
    sound: ISoundItem
}>()

const {
    timerState,
    timerDisplayTime,
    startTimer,
    clearTimer
} = useTimer(false)

const getSoundDate = () => {
    return new Date(props.sound.timestamp).toLocaleString()
}

watch(() => props.sound.timerStartValue, (value) => {
    if(value) {
        clearTimer()
        startTimer({ value: value })
    }
}, {
    immediate: true
})

</script>

<style scoped lang="scss">
.sound-notification-item {
  @apply py-2;
}
.sound-notification-item-timer {
  font-variant-numeric: tabular-nums;
}
</style>
